
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


const RouteScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    let firstFrame;
    let secondFrame;

    const scrollToRoutePosition = () => {
      if (hash) {
        const targetId = decodeURIComponent(hash.slice(1));
        const target = document.getElementById(targetId);

        if (target) {
          target.scrollIntoView({ behavior: "auto", block: "start" });
          return;
        }
      }

      window.scrollTo(0, 0);
    };

    // Wait until the new route's DOM is mounted before resolving the hash.
    firstFrame = window.requestAnimationFrame(() => {
      secondFrame = window.requestAnimationFrame(scrollToRoutePosition);
    });

    return () => {
      window.cancelAnimationFrame(firstFrame);
      if (secondFrame) window.cancelAnimationFrame(secondFrame);
    };
  }, [pathname, hash]);

  return null;
};

export default RouteScrollToTop;
